var Packet = /** @class */ (function () {
    function Packet(props) {
        this.prices = [];
        this.stretches = [];
        this.collaboratorStretches = [];
        // console.log('Packet - constructor - props: ', props)
        Object.assign(this, props);
    }
    return Packet;
}());
export default Packet;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Packets/Model.ts
// module id = 204
// module chunks = 0